/**
 * components/landing/home/FinalCTA.jsx — Section 14.
 *
 * Cinematic closing section: giant headline, dual CTAs, moving background
 * glow.  Sits just before the FooterCta banner — semantically similar but
 * this one is the actual homepage-owned closer with bespoke copy from
 * the Phase 2 PRD.
 */

import { Container, GradientButton, GhostButton, Eyebrow } from '../design-system'
import { Sparkles } from 'lucide-react'

const FinalCTA = () => (
  <section className="relative py-28 md:py-40 overflow-hidden">
    {/* Backdrop */}
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10">
      <div className="absolute inset-0 opacity-90" style={{ background: 'radial-gradient(60% 50% at 50% 50%, rgba(255,193,7,0.16), transparent 70%)' }} />
      <div className="absolute inset-0 opacity-50" style={{ background: 'radial-gradient(40% 30% at 30% 80%, rgba(16,185,129,0.12), transparent 70%)' }} />
      <div className="absolute inset-0 opacity-30 [background-image:radial-gradient(1.2px_1.2px_at_20%_20%,rgba(255,255,255,0.5),transparent),radial-gradient(1px_1px_at_60%_60%,rgba(255,255,255,0.4),transparent),radial-gradient(1px_1px_at_80%_35%,rgba(255,255,255,0.3),transparent)]" />
    </div>
    <Container>
      <div className="max-w-3xl mx-auto text-center space-y-6">
        <Eyebrow>The Kalki Ai Cloud closer</Eyebrow>
        <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-white leading-[1.03]">
          Build your AI trading business<br />
          on <span className="bg-gradient-to-r from-brand-gold via-[#FFE17A] to-brand-gold bg-clip-text text-transparent">Kalki Ai Cloud</span>.
        </h2>
        <p className="text-zinc-400 md:text-lg leading-relaxed max-w-2xl mx-auto">
          Stop building infrastructure. Start building your business.
          Kalki Ai Cloud provides the enterprise technology while you focus on growth.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
          <GradientButton href="/contact" size="lg">Schedule Demo</GradientButton>
          <GhostButton href="/get-started" size="lg">Launch Platform</GhostButton>
        </div>
        <div className="pt-4 inline-flex items-center gap-2 text-[12px] text-zinc-500 font-mono">
          <Sparkles className="h-3.5 w-3.5 text-brand-gold" />
          Onboarding usually completes in 2-4 weeks
        </div>
      </div>
    </Container>
  </section>
)

export default FinalCTA
